<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="group-membership-layout">
  <app-admin-groups-membership-list [users]="nonMembers$ | async" [canEdit]="canEdit"
    (createMembership)="createMembership($event)"></app-admin-groups-membership-list>
  <app-admin-groups-member-list [memberships]="memberships$ | async" [users]="members$ | async" [canEdit]="canEdit"
    (deleteMembership)="deleteMembership($event)" (editMembership)="editMembership($event)"></app-admin-groups-member-list>
</div>
